import { Maybe } from '@ts/operations'
import { DateTime } from 'luxon'
import React from 'react'

import Countdown from './Countdown'

export type CountdownSaleType = {
  endDate: Maybe<string>
  id: Maybe<string>
  name: string
  startDate: Maybe<string>
}

const StoresCountdownProvider = ({
  currentSale,
  sales,
}: {
  currentSale: CountdownSaleType
  sales: Array<CountdownSaleType | null>
}) => {
  const currentSaleIndex = sales.indexOf(currentSale)
  const nextSale = sales[currentSaleIndex + 1]
  if (!nextSale) return null

  return (
    <Countdown
      endsAt={DateTime.fromISO(currentSale.endDate as string)}
      message="Prices increase in:"
    />
  )
}

export default StoresCountdownProvider
